import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    SuccessFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { useLocation, useNavigate } from 'react-router-dom';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';

interface IFeedbackData {
    stateFeedback: string;
    err: any;
}
export const FeedbackOTPProcess: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const { state } = useLocation();
    const { stateFeedback, err }: IFeedbackData = state;
    const path: string = sessionStorage.getItem('pathOrigin')!;
    const size = useWindowSize();
    const navigate = useNavigate();

    const sendToNative = (url: string) => {
        window.close();
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='feedbackOtpProcess-page'
            style={{
                background:
                    stateFeedback === 'SUCCESS'
                        ? size.width < 1024 || size.height < 550
                            ? skinVars.colors.backgroundBrand
                            : ''
                        : skinVars.colors.background,
            }}
        >
            {stateFeedback === 'SUCCESS' ? (
                <SuccessFeedbackScreen
                    title={t('contactVerificationSuccessTitle')}
                    description={t('feedbackSuccessSubtitle')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative(path);
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></SuccessFeedbackScreen>
            ) : (
                <ErrorFeedbackScreen
                    title={err.title}
                    description={err.localizedDescription}
                    errorReference={'Código de error: ' + `${err.id}`}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                navigate('/profile');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></ErrorFeedbackScreen>
            )}
        </div>
    );
};

export default FeedbackOTPProcess;
